//utils
import { calculDuree } from './calcul-duree'

//data
import {grilleDuree } from '../data/mock.js'

export function getTotalPanier(dbArticles,panier,location) {

    let total = 0;

    let nbCombos = 0; //qte de formule combi/planche
    let typeQty = [0, 0];//tableau pour cumuler les articles par type [0]:type1(planche) [1]:type2(combi)


    panier.forEach(article => {

        let currentArticle = dbArticles.find(art => art.id_article === article.article_id);


        total += getArticleTarif(article, 0, dbArticles,location);

        //cumuler les types:
        typeQty[currentArticle.type_id - 1] += article.qte;
        //on garde la plus petite des 2 valeurs (après tri) pour connaitre la qté de formule
    })

    nbCombos = typeQty.toSorted((q1, q2) => q1 < q2 ? -1 : 1)[0];

    //on cherche la différence entre la formule et le cumul planche+combi
    // NB : Faire plus propre que 'tarif.grille_id === 1'


    let tarifBasePlanche = getArticleTarif({ qte: 1 }, 1,dbArticles,location); //tarif 1 planche pour cette période(location)
    let tarifBaseCombi = getArticleTarif({ qte: 1 }, 2,dbArticles,location); //tarif 1 combi pour cette période(location)
    let tarifBaseFormule = getArticleTarif({ qte: 1 }, 3,dbArticles,location); //tarif 1 formule pour cette période(location)

    let difference = (tarifBasePlanche + tarifBaseCombi) - tarifBaseFormule;

    return({ total: total, difference: difference, combos: nbCombos });
}


export function getArticleTarif(article, idGrille, dbArticles,location) { //on ajoute la params idGrille pour calculer les différences des formules
    // si idGrille == 0 , on cacule tarif d'un article normal
    // si idGrille >0, on calcule juste le tarif d'une grille 

    let tarifArticle = 0;
    let currentArticle = {};
    let currentGrilleId = 0;

    if (idGrille > 0) { //on veut le tarif de la grille
        currentGrilleId = idGrille;
    } else { //on veut le tarif de l'article
        currentArticle = dbArticles.find(art => art.id_article === article.article_id);
        currentGrilleId = currentArticle.grille_id
    }

    let currentTarif = grilleDuree.find(tarif => tarif.grille_id === currentGrilleId && tarif.duree_id === calculDuree(location).id_duree)



    //Attention : calcul dégressif des jours
    if (calculDuree(location).id_duree === 6 && calculDuree(location).qte > 1) { //duree > 1 jour
        //liste des déressivité par grille de tarif [planche, combi,formule]
        let degressivite = [[20, 20, 10], [5], [25, 15, 10]];
        //on recupere les bonnes valeurs degressif en fonction de la grille courante (planche, combi...)
        let degressiviteGrille = degressivite[currentTarif.grille_id - 1];

        //tarif du premier jour: tarifjour * qte Article
        tarifArticle = currentTarif.tarif * article.qte

        // puis au jour le jour
        for (let i = 0; i < calculDuree(location).qte - 1; i++) {

            let ind = i < degressiviteGrille.length ? i : degressiviteGrille.length - 1;
            tarifArticle += degressiviteGrille[ind] * article.qte

        }



    } else {
        tarifArticle = currentTarif.tarif * calculDuree(location).qte * article.qte
    }

    return tarifArticle;
}


export function getArticlePU(article,dbArticles,location) { //on ajoute la params idGrille pour calculer les différences des formules
    // si idGrille == 0 , on cacule tarif d'un article normal
    // si idGrille >0, on calcule juste le tarif d'une grille 

    let tarifArticle = 0;

    let currentTarif = grilleDuree.find(tarif => tarif.grille_id === article.grille_id && tarif.duree_id === calculDuree(location).id_duree)


    //Attention : calcul dégressif des jours
    if (calculDuree(location).id_duree === 6 && calculDuree(location).qte > 1) { //duree > 1 jour
        //liste des déressivité par grille de tarif [planche, combi,formule]
        let degressivite = [[20, 20, 10], [5], [25, 15, 10]];
        //on recupere les bonnes valeurs degressif en fonction de la grille courante (planche, combi...)
        let degressiviteGrille = degressivite[currentTarif.grille_id - 1];

        //tarif du premier jour: tarifjour * qte Article
        tarifArticle = currentTarif.tarif

        // puis au jour le jour
        for (let i = 0; i < calculDuree(location).qte - 1; i++) {

            let ind = i < degressiviteGrille.length ? i : degressiviteGrille.length - 1;
            tarifArticle += degressiviteGrille[ind] 

        }



    } else {
        tarifArticle = currentTarif.tarif * calculDuree(location).qte 
    }

    return tarifArticle;
}

 //transformer les infos de tarifs avec les centimes
 export function tarifDecimalConverter(tarif){
    let entier = Math.floor(parseFloat(tarif))
    let deci = String(Math.round((tarif - entier)*100));
    
    if (deci.length < 2) //centimes <10
    { deci = "0"+deci; }
    else{
      deci = deci.slice(0,2);
    }
    return String(entier)+","+deci;

  }